'use client';
import classNames from 'classnames';
import './index.scss';

export interface EfIconProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc: string;
    /**
     * 介绍这是个什么图片
     */
    alt?: string;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 图标容器
 *
 * 为提升性能,使用 background 来展示,因此使用时必须给这个容器设置高度,宽度默认为100%
 *
 * 其中只展示图片中间部分,即 background-size: cover;
 */
export default function EfIcon({ className = '', alt = '', pc }: EfIconProps) {
    const prefixCls = 'ef-icon';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });
    return (
        <div className={compCls} data-alt={alt || null}>
            <figure
                className={`${prefixCls}-item`}
                style={{
                    backgroundImage: `url('${pc}')`,
                }}
            ></figure>
        </div>
    );
}
